import { useMemo } from 'react';
// routes
import { paths } from 'src/routes/paths';
// locales
import { useLocales } from 'src/locales';
// components
import Label from 'src/components/label';
import Iconify from 'src/components/iconify';
import SvgColor from 'src/components/svg-color';

// ----------------------------------------------------------------------

const icon = (name) => (
  <SvgColor src={`/assets/icons/navbar/${name}.svg`} sx={{ width: 1, height: 1 }} />
  // OR
  // <Iconify icon="fluent:mail-24-filled" />
  // https://icon-sets.iconify.design/solar/
  // https://www.streamlinehq.com/icons
);

const ICONS = {
  job: icon('ic_job'),
  blog: icon('ic_blog'),
  chat: icon('ic_chat'),
  mail: icon('ic_mail'),
  user: icon('ic_user'),
  file: icon('ic_file'),
  lock: icon('ic_lock'),
  tour: icon('ic_tour'),
  order: icon('ic_order'),
  label: icon('ic_label'),
  blank: icon('ic_blank'),
  kanban: icon('ic_kanban'),
  folder: icon('ic_folder'),
  banking: icon('ic_banking'),
  booking: icon('ic_booking'),
  invoice: icon('ic_invoice'),
  product: icon('ic_product'),
  calendar: icon('ic_calendar'),
  disabled: icon('ic_disabled'),
  external: icon('ic_external'),
  menuItem: icon('ic_menu_item'),
  ecommerce: icon('ic_ecommerce'),
  analytics: icon('ic_analytics'),
  dashboard: icon('ic_dashboard'),
};

// ----------------------------------------------------------------------

export function useNavData() {
  const { t } = useLocales();

  const data = useMemo(
    () => [
      // OVERVIEW
      // ----------------------------------------------------------------------
      {
        subheader: t('overview'),
        items: [
          {
            title: t('dashboard'),
            path: paths.dashboard.root,
            icon: ICONS.dashboard,
          },
        ],
      },

      // MANAGEMENT
      // ----------------------------------------------------------------------
      {
        subheader: t('management'),
        items: [
          // QR SCANNER
          {
            title: t('QR Scanner'),
            path: paths.scan.barcode,
            icon: ICONS.user,
          },
          // PATIENTS
          {
            title: t('New Registration'),
            path: paths.patients.new_patient,
            icon: ICONS.user,
            roles: ['Reception'],
          },
          {
            title: t('Re-visit'),
            path: paths.patients.revisit,
            icon: ICONS.user,
            roles: ['Reception'],
          },
          {
            title: t('Manage Patients'),
            path: paths.patients.list,
            icon: ICONS.user,
            roles: ['Reception'],
          },
          {
            title: t("Doctor's Enquiry"),
            path: paths.doctors.enquiry,
            icon: ICONS.user,
            roles: ['Reception'],
          },

          // ADMISSIONS
          {
            title: t('IP Admission'),
            path: '#',
            icon: ICONS.user,
            roles: ['Reception'],
            children: [
              {
                title: t('Room Booking'),
                path: paths.dashboard.user.list,
                roles: ['Reception'],
              },
              {
                title: t('Room Availability'),
                path: paths.dashboard.user.list,
                roles: ['Reception'],
              },
            ],
          },

          // EMR - Electronic Medical Record
          {
            title: t('Awaiting Screening'),
            path: paths.emr.screening.awaiting,
            icon: ICONS.user,
            roles: ['ScreeningOp'],
          },
          {
            title: t('Screening In Progress'),
            path: paths.emr.screening.progress,
            icon: ICONS.user,
            roles: ['ScreeningOp'],
          },
          {
            title: t('Screening Completed'),
            path: paths.emr.screening.completed,
            icon: ICONS.user,
            roles: ['ScreeningOp'],
          },
          /* {
            title: t('user'),
            path: paths.dashboard.user.root,
            icon: ICONS.user,
            children: [
              { title: t('list'), path: paths.dashboard.user.list },
              { title: t('create'), path: paths.dashboard.user.new },
            ],
          }, */
        ],
      },

      // EXTENDED
      // ----------------------------------------------------------------------
      {
        subheader: t('Extended'),
        items: [
          // REPORTS
          {
            title: t('Reports'),
            path: '#',
            icon: ICONS.user,
            roles: ['Reception'],
            children: [
              {
                title: t('OP Registration'),
                path: paths.report.op_registration_report,
                roles: ['Reception'],
              },
              {
                title: t('OP Transaction'),
                path: paths.report.op_transaction_report,
                roles: ['Reception'],
              },
              {
                title: t('OP Statistics'),
                path: paths.report.op_statistics_report,
                roles: ['Reception'],
              },
              /* {
                title: t('Yearly Register'),
                path: paths.report.op_yearly_register,
                roles: ['Reception'],
              }, */
            ],
          },
        ],
      },

      // ADMINISTRATION
      // ----------------------------------------------------------------------
      {
        subheader: t('Masters'),
        roles: ['Admin'],
        items: [
          // DOCTORS
          {
            title: t('Doctors'),
            path: paths.doctors.root,
            icon: ICONS.user,
            roles: ['Admin'],
            children: [
              { title: t('New Doctor'), path: paths.doctors.new, roles: ['Admin'] },
              { title: t('Manage Doctors'), path: paths.doctors.list, roles: ['Admin'] },
            ],
          },
          // MASTERS
          {
            title: t('Masters'),
            path: paths.masters.root,
            icon: ICONS.user,
            roles: ['Admin'],
            children: [
              { title: t('Departments'), path: paths.masters.departments, roles: ['Admin'] },
              {
                title: t('Payment Settings'),
                path: paths.masters.payment_settings,
                roles: ['Admin'],
              },
            ],
          },
        ],
      },
    ],
    [t]
  );

  return data;
}
